import React from 'react';

export default function PadlockIcon(props) {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
      <path
        fill='#111'
        d='M16 4c4.159 0 5.656 2.033 5.945 6.565l.017.287.023.58.013.606.001.802-.001.159H23c1.105 0 2 .896 2 2V26c0 1.105-.895 2-2 2H9c-1.105 0-2-.895-2-2V15c0-1.105.895-2 2-2l1.003-.001v-1.062l.012-.605c.01-.33.024-.646.045-.951l.035-.449.054-.515C10.599 5.647 12.165 4 16 4zm0 13.333c-1.105 0-2 .896-2 2 0 .74.402 1.387 1 1.733V23l.008.125c.061.493.482.875.992.875.552 0 1-.448 1-1l.001-1.935c.597-.346.999-.992.999-1.732 0-1.104-.895-2-2-2zM16 6c-2.434 0-3.462.806-3.827 3.258l-.033.234-.047.431-.01.113-.01.114-.032.477-.006.124-.006.127-.018.524-.009.558-.001.785.001.254h7.993l.005-.646-.006-.586-.015-.553-.024-.52-.034-.487C19.658 7.061 18.67 6 16 6z'
      />
    </svg>
  );
}
